import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Share2, Linkedin, Twitter } from 'lucide-react';

interface BlogPostFooterProps {
    tags?: string[];
}

export const BlogPostFooter: React.FC<BlogPostFooterProps> = ({ tags }) => {
    return (
        <div className="mt-20 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex flex-wrap gap-2">
                {tags?.map(tag => (
                    <Badge key={tag} variant="outline" className="text-muted-foreground hover:text-foreground cursor-pointer">#{tag}</Badge>
                ))}
            </div>
            <div className="flex items-center gap-3">
                <span className="text-sm font-medium text-muted-foreground">Share:</span>
                <Button size="icon" variant="ghost" className="h-8 w-8 rounded-full hover:bg-blue-100 hover:text-blue-600"><Twitter size={16} /></Button>
                <Button size="icon" variant="ghost" className="h-8 w-8 rounded-full hover:bg-blue-100 hover:text-blue-700"><Linkedin size={16} /></Button>
                <Button size="icon" variant="ghost" className="h-8 w-8 rounded-full hover:bg-muted"><Share2 size={16} /></Button>
            </div>
        </div>
    );
};
